import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'

type Props = {
  onGenerate: () => void
}

export const ContractsHeader = ({ onGenerate }: Props) => {
  const { t } = useLocales()

  return (
    <Flex justify="flex-end">
      <Button onClick={onGenerate} icon={<Add size={16} />} type="primary">
        {t('contracts.generate_contract') || 'Generate Contract'}
      </Button>
    </Flex>
  )
}
